import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-inlinesvg';
import AngleDownIcon from '../../images/angleDown.svg';

const isChildMatch = navigation => {
  if (navigation.items && navigation.items.length > 0) {
    return navigation.items.filter(i => isChildMatch(i)).length > 0;
  }
  return (
    navigation.matchPath !== undefined &&
    (navigation.matchPath.toLowerCase() === window.location.pathname.toLowerCase() ||
      window.location.pathname
        .toLowerCase()
        .lastIndexOf(`${navigation.matchPath}/`.toLowerCase(), 0) === 0)
  );
};

class NavigationItem extends Component {
  constructor() {
    super();
    this.state = {
      isSubMenuShow: false,
      isMatched: false,
    };
    this.handleSubMenuShow = this.handleSubMenuShow.bind(this);
  }

  componentDidMount() {
    const isMatched = isChildMatch(this.props);
    /* eslint-disable react/no-did-mount-set-state */
    this.setState({ isSubMenuShow: isMatched, isMatched });
  }

  componentWillReceiveProps(nextProps) {
    const isMatched = isChildMatch(nextProps);
    this.setState({ isSubMenuShow: isMatched, isMatched });
  }
  handleSubMenuShow(e) {
    e.preventDefault();
    this.setState(prev => ({ isSubMenuShow: !prev.isSubMenuShow }));
  }

  render() {
    const { isSubMenuShow, isMatched } = this.state;
    const { items, title, icon, linkComponent, onLinkClick, primaryColor } = this.props;
    if (items && items.length !== 0) {
      return (
        <li className={`apollo-sidebar-navigation-item ${isMatched ? 'child-active' : ''}`}>
          <a
            onClick={this.handleSubMenuShow}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <div style={{ display: 'flex' }}>
              {icon && (
                <div
                  className="apollo-sidebar-navigation-icon"
                  style={{ color: isMatched ? primaryColor : '#777' }}
                >
                  {icon}
                </div>
              )}
              <div className="apollo-sidebar-navigation-text">{title}</div>
            </div>
            <span
              className={`apollo-header-menu-icon ${isSubMenuShow ? 'active' : ''}`}
              style={{
                marginRight: 0,
                marginBottom: '1px',
                color: isMatched ? primaryColor : '#777',
              }}
            >
              <ReactSVG src={AngleDownIcon} />
            </span>
          </a>
          <ul className={`apollo-sidebar-navigation-submenu ${isSubMenuShow ? 'open' : ''}`}>
            {items.map((subItem, idx) => {
              return (
                <NavigationItem
                  {...subItem}
                  key={idx}
                  onLinkClick={onLinkClick}
                  primaryColor={primaryColor}
                />
              );
            })}
          </ul>
        </li>
      );
    }

    return (
      <li
        className={`apollo-sidebar-navigation-item ${isMatched ? 'active' : ''}`}
        style={{ background: isMatched ? primaryColor : 'inherit' }}
      >
        {linkComponent !== undefined &&
          React.cloneElement(
            linkComponent,
            { onClick: onLinkClick },
            <div style={{ display: 'flex' }}>
              {icon && <div className="apollo-sidebar-navigation-icon">{icon}</div>}
              <div className="apollo-sidebar-navigation-text">{title}</div>
            </div>
          )}
      </li>
    );
  }
}

NavigationItem.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node,
  matchPath: PropTypes.string,
  linkComponent: PropTypes.node,
  items: PropTypes.array,
  scrollTop: PropTypes.func,
  onLinkClick: PropTypes.func,
  primaryColor: PropTypes.string,
  location: PropTypes.object,
};

export default NavigationItem;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/SideBar/components/NavigationItem/index.js
 **/